import { render, staticRenderFns } from "./PageTitleBar.vue?vue&type=template&id=f2bd8d7c&scoped=true"
import script from "./PageTitleBar.vue?vue&type=script&lang=js"
export * from "./PageTitleBar.vue?vue&type=script&lang=js"
import style0 from "./PageTitleBar.vue?vue&type=style&index=0&id=f2bd8d7c&prod&scoped=true&lang=css"
import style1 from "./PageTitleBar.vue?vue&type=style&index=1&id=f2bd8d7c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2bd8d7c",
  null
  
)

export default component.exports